export const ScadaConfigurationPathConstants = {
  GET_STENCILS: '/visualization/sidebarItems',
  GET_ASSET_GRAPHS: '/visualization/getLayout',
  SAVE_CONFIGURATION: '/visualization/setLayout',
  GET_QUESTIONS: '/visualization/equipmentQuestions',
  SUBMIT_ANSWER: '/visualization/submitAnswers',
  FETCH_SENSORS: '/visualization/sensorList',
  SAVE_EQUIPMENT_SENSORS: '/visualization/createSensor',
  FETCH_EQUIPMENT_SENSORS: '/visualization/fetchEquipmentSensors',
  ADD_SENSOR_TO_EQUIPMENT: 'visualization/addSensors',
  REAL_TIME_SCADA: 'visualization/realTimeScada',
  FETCH_BREADCRUMS: '/visualization/breadcrumbs',
  DELETE_SENSOR: '/visualization/deleteSensor',
  DELETE_EQUIPMENT: '/visualization/deleteEquipment',
  GET_ENTITY_DETAILS: '/visualization/entityName',
  DOWNLOAD_TAGS: '/visualization/downloadTags',
  DELETED_SENSORS_LIST: '/visualization/deletedSensors',
  RESTORE_SENSOR: '/visualization/restoreSensor',
  GET_TIME_BASED_SCADA: '/visualization/getTimeBasedScada',
  GET_MANUAL_FREQUENCY_DATA: '/visualization/getManualSensorFrequency'
};
